import React from "react";
import "./Spinner.css";

const Spinner = ({ size = "md", color = "#EF4346" }) => {
  return (
    <div className="container-fluid mt-5 d-flex align-items-center justify-content-center">
      <div className="d-flex align-items-center justify-content-center h-100">
        <div className="dot-spinner">
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
          <div className="dot-spinner__dot"></div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
